import { render, staticRenderFns } from "./editShipmentForm.vue?vue&type=template&id=13bdfbb0"
import script from "./editShipmentForm.vue?vue&type=script&lang=js"
export * from "./editShipmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports